<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Author’s Note</a></p>
<p class="toc sub"><a href="#/front04">Prologue</a></p>
<p class="part"><a href="#/c001">Part 1: Year One</a></p>
<p class="toc"><a href="#/c01">Welcome to Longwood</a></p>
<p class="toc"><a href="#/c02">The Golden Class</a></p>
<p class="toc"><a href="#/c03">It Will Pass, and You Will Be Fine</a></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">First Paycheck Party</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">The Mythical Day Team</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Mania</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">The Lightbulb Has to Want to Be Changed</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">These Are Bad, but I Think You Can Do Worse</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Night Float</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Controlled Chaos</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">Insomnia and Electric Shocks</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Bread-and-Butter Medicine</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Stern and Sons</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">A Face Worth Licking</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Tongue-Tied Cherry Stems South of the Border</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">Part 2: Year Two</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">Like the First Year, but More</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">Unwelcome Departures</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Snoozers Lose</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Tell Me What Brings You into the Office</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">The Irresistible Lure of Delivering Chinese Food</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Just Needing Some Air</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">Some Kind of Chicken Sociopath</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Like Free Therapy</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">The Joy and Sorrow of Musical Staircases</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">EXP</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">An Office with a Window</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">Friends Don’t Have Sleepovers</span></p>
<p class="part"><span href="#/c003" title="Link target outside of Sample">Part 3: Years Three and Four</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">Don’t Just Do Something, Sit There</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">Being Present</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">California Nightmares</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">Not My Choice</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">The Match Redux</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">I’ve Got Muscles</span></p>
<p class="toc"><span href="#/c34" title="Link target outside of Sample">An Impostor Once More</span></p>
<p class="toc"><span href="#/c35" title="Link target outside of Sample">This Is Where Change Happens</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">In Memoriam</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Connect on Social Media</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?41de1a14